import React from 'react';

export default function TermsScreen() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <span style={styles.logo}>📱</span>
          <h1 style={styles.brand}>Peekr</h1>
        </div>

        <h2 style={styles.title}>Terms of Use</h2>
        <p style={styles.updated}>Last updated: February 2026</p>

        <Section title="Acceptance of Terms">
          By downloading, installing, or using Peekr, you agree to be bound by these Terms of Use.
          If you do not agree to these terms, do not use the app. These terms apply to all users
          of Peekr, including hosts who share content and viewers who join sessions.
        </Section>

        <Section title="Description of Service">
          Peekr is a real-time content sharing application that allows hosts to broadcast photos,
          videos, and documents to viewers via a web browser. Viewers can join sessions without
          downloading an app by visiting getpeekr.com and entering a room code.
        </Section>

        <Section title="Subscriptions and Payments">
          Peekr offers free and premium subscription tiers. Premium subscriptions are processed
          through Apple's App Store or Google Play. Subscription fees are charged to your payment
          method at the time of purchase and automatically renew unless cancelled at least 24 hours
          before the end of the current period. You can manage and cancel subscriptions in your
          device's account settings. No refunds are provided for partial subscription periods except
          as required by applicable law.
        </Section>

        <Section title="Acceptable Use">
          You agree not to use Peekr to share content that is illegal, harmful, threatening,
          abusive, defamatory, obscene, or otherwise objectionable. You must not share content
          that infringes the intellectual property rights of others. You must not use Peekr to
          transmit spam, malware, or any harmful code. Ebenova Solutions reserves the right to
          terminate access for any violation of these terms.
        </Section>

        <Section title="Content Ownership">
          You retain all ownership rights to the content you share through Peekr. By sharing
          content via Peekr, you grant Ebenova Solutions a temporary, limited licence to transmit
          that content to viewers you have invited for the duration of your session. Content is
          not stored permanently by Peekr and is removed after sessions end.
        </Section>

        <Section title="Intellectual Property">
          The Peekr application, including its design, code, branding, and all related materials,
          is the property of Ebenova Solutions and is protected by applicable intellectual property
          laws. You may not copy, modify, distribute, or create derivative works based on Peekr
          without express written permission.
        </Section>

        <Section title="Disclaimer of Warranties">
          Peekr is provided "as is" without warranties of any kind, express or implied. Ebenova
          Solutions does not warrant that the service will be uninterrupted, error-free, or free
          from harmful components. Your use of Peekr is at your sole risk. We do not warrant the
          accuracy, completeness, or usefulness of any content shared through the service.
        </Section>

        <Section title="Limitation of Liability">
          To the maximum extent permitted by applicable law, Ebenova Solutions shall not be liable
          for any indirect, incidental, special, consequential, or punitive damages arising from
          your use of or inability to use Peekr, even if we have been advised of the possibility
          of such damages. Our total liability to you for any claims arising from these terms or
          your use of Peekr shall not exceed the amount you paid for your subscription in the
          twelve months prior to the claim.
        </Section>

        <Section title="Changes to the Service">
          Ebenova Solutions reserves the right to modify, suspend, or discontinue Peekr at any
          time with or without notice. We may also update these Terms of Use from time to time.
          Continued use of Peekr after changes to these terms constitutes your acceptance of the
          revised terms.
        </Section>

        <Section title="Governing Law">
          These Terms of Use shall be governed by and construed in accordance with the laws of
          the jurisdiction in which Ebenova Solutions operates, without regard to its conflict
          of law provisions.
        </Section>

        <Section title="Contact">
          Questions about these Terms of Use? Contact us at:<br /><br />
          <b style={styles.b}>Ebenova Solutions</b><br />
          legal@getpeekr.com
        </Section>

        <div style={styles.footer}>
          <a href="/" style={styles.link}>← Back to Peekr</a>
          <span style={styles.divider}> · </span>
          <a href="/privacy" style={styles.link}>Privacy Policy</a>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={styles.section}>
      <h3 style={styles.sectionTitle}>{title}</h3>
      <p style={styles.sectionBody}>{children}</p>
    </div>
  );
}

const styles = {
  page: { backgroundColor: '#050C1A', minHeight: '100vh', color: '#FFFFFF', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
  container: { maxWidth: 680, margin: '0 auto', padding: '48px 24px' },
  header: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 40 },
  logo: { fontSize: 32 },
  brand: { fontSize: 28, fontWeight: 800, color: '#FFFFFF', letterSpacing: 2, margin: 0 },
  title: { fontSize: 32, fontWeight: 700, color: '#FFFFFF', marginBottom: 8 },
  updated: { fontSize: 13, color: '#3A5570', marginBottom: 40 },
  section: { marginBottom: 36, borderLeft: '2px solid #122038', paddingLeft: 20 },
  sectionTitle: { fontSize: 16, fontWeight: 700, color: '#00D4FF', marginBottom: 10, letterSpacing: 1 },
  sectionBody: { fontSize: 14, color: '#6A85A0', lineHeight: 1.8, margin: 0 },
  b: { color: '#FFFFFF', fontWeight: 600 },
  footer: { marginTop: 60, paddingTop: 24, borderTop: '1px solid #122038' },
  link: { color: '#00D4FF', textDecoration: 'none', fontSize: 14 },
  divider: { color: '#3A5570', fontSize: 14 },
};
